// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gportal/api/user/v1/requests.proto (package gportal.api.user.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Paranoid } from "../../../type/v1/paranoid_pb.js";

/**
 * @generated from message gportal.api.user.v1.GetUserRequest
 */
export class GetUserRequest extends Message<GetUserRequest> {
  constructor(data?: PartialMessage<GetUserRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.GetUserRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetUserRequest {
    return new GetUserRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetUserRequest {
    return new GetUserRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetUserRequest {
    return new GetUserRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetUserRequest | PlainMessage<GetUserRequest> | undefined, b: GetUserRequest | PlainMessage<GetUserRequest> | undefined): boolean {
    return proto3.util.equals(GetUserRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.GetCustomerRequest
 */
export class GetCustomerRequest extends Message<GetCustomerRequest> {
  constructor(data?: PartialMessage<GetCustomerRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.GetCustomerRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCustomerRequest {
    return new GetCustomerRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCustomerRequest {
    return new GetCustomerRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCustomerRequest {
    return new GetCustomerRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCustomerRequest | PlainMessage<GetCustomerRequest> | undefined, b: GetCustomerRequest | PlainMessage<GetCustomerRequest> | undefined): boolean {
    return proto3.util.equals(GetCustomerRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.CreateCustomerRequest
 */
export class CreateCustomerRequest extends Message<CreateCustomerRequest> {
  /**
   * @generated from field: optional string currency = 1;
   */
  currency?: string;

  /**
   * @generated from field: optional string reference_id = 2;
   */
  referenceId?: string;

  constructor(data?: PartialMessage<CreateCustomerRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.CreateCustomerRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "reference_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateCustomerRequest {
    return new CreateCustomerRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateCustomerRequest {
    return new CreateCustomerRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateCustomerRequest {
    return new CreateCustomerRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateCustomerRequest | PlainMessage<CreateCustomerRequest> | undefined, b: CreateCustomerRequest | PlainMessage<CreateCustomerRequest> | undefined): boolean {
    return proto3.util.equals(CreateCustomerRequest, a, b);
  }
}

/**
 * The length limits are Chargebee's for the billing address this ends up in. The handler checks
 * the rest: that the country is one we serve, and that the postal code belongs to it.
 *
 * @generated from message gportal.api.user.v1.UpdateBillingAddressRequest
 */
export class UpdateBillingAddressRequest extends Message<UpdateBillingAddressRequest> {
  /**
   * @generated from field: string firstname = 1;
   */
  firstname = "";

  /**
   * @generated from field: string lastname = 2;
   */
  lastname = "";

  /**
   * ISO 3166-1 alpha-2 country code.
   *
   * @generated from field: string country = 3;
   */
  country = "";

  /**
   * Validated against the country, so it must be a real postal code there. Optional for the
   * countries that have no postal code system, and for those where we do not insist on one.
   *
   * @generated from field: string postal_code = 4;
   */
  postalCode = "";

  /**
   * @generated from field: string locality = 5;
   */
  locality = "";

  /**
   * @generated from field: string street = 6;
   */
  street = "";

  constructor(data?: PartialMessage<UpdateBillingAddressRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.UpdateBillingAddressRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "firstname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "lastname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "postal_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "locality", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "street", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateBillingAddressRequest {
    return new UpdateBillingAddressRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateBillingAddressRequest {
    return new UpdateBillingAddressRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateBillingAddressRequest {
    return new UpdateBillingAddressRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateBillingAddressRequest | PlainMessage<UpdateBillingAddressRequest> | undefined, b: UpdateBillingAddressRequest | PlainMessage<UpdateBillingAddressRequest> | undefined): boolean {
    return proto3.util.equals(UpdateBillingAddressRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.RegisterUserRequest
 */
export class RegisterUserRequest extends Message<RegisterUserRequest> {
  /**
   * @generated from field: string email = 1;
   */
  email = "";

  /**
   * @generated from field: string password = 2;
   */
  password = "";

  /**
   * @generated from field: string username = 4;
   */
  username = "";

  /**
   * @generated from field: string firstname = 5;
   */
  firstname = "";

  /**
   * @generated from field: string lastname = 6;
   */
  lastname = "";

  /**
   * @generated from field: string country = 7;
   */
  country = "";

  /**
   * @generated from field: string postal_code = 8;
   */
  postalCode = "";

  /**
   * @generated from field: string locality = 9;
   */
  locality = "";

  /**
   * @generated from field: string street = 10;
   */
  street = "";

  /**
   * @generated from field: string locale = 11;
   */
  locale = "";

  /**
   * @generated from field: string timezone = 12;
   */
  timezone = "";

  /**
   * @generated from field: bool newsletter = 13;
   */
  newsletter = false;

  /**
   * @generated from field: bool terms = 14;
   */
  terms = false;

  /**
   * @generated from field: string recaptcha_token = 15;
   */
  recaptchaToken = "";

  constructor(data?: PartialMessage<RegisterUserRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.RegisterUserRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "firstname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "lastname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "postal_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "locality", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "street", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "locale", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "newsletter", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 14, name: "terms", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "recaptcha_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RegisterUserRequest {
    return new RegisterUserRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RegisterUserRequest {
    return new RegisterUserRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RegisterUserRequest {
    return new RegisterUserRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RegisterUserRequest | PlainMessage<RegisterUserRequest> | undefined, b: RegisterUserRequest | PlainMessage<RegisterUserRequest> | undefined): boolean {
    return proto3.util.equals(RegisterUserRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.RegisterUserRequirementsRequest
 */
export class RegisterUserRequirementsRequest extends Message<RegisterUserRequirementsRequest> {
  /**
   * @generated from field: optional string locale = 1;
   */
  locale?: string;

  constructor(data?: PartialMessage<RegisterUserRequirementsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.RegisterUserRequirementsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "locale", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RegisterUserRequirementsRequest {
    return new RegisterUserRequirementsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RegisterUserRequirementsRequest {
    return new RegisterUserRequirementsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RegisterUserRequirementsRequest {
    return new RegisterUserRequirementsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RegisterUserRequirementsRequest | PlainMessage<RegisterUserRequirementsRequest> | undefined, b: RegisterUserRequirementsRequest | PlainMessage<RegisterUserRequirementsRequest> | undefined): boolean {
    return proto3.util.equals(RegisterUserRequirementsRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.GetProfileRequest
 */
export class GetProfileRequest extends Message<GetProfileRequest> {
  constructor(data?: PartialMessage<GetProfileRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.GetProfileRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetProfileRequest {
    return new GetProfileRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetProfileRequest {
    return new GetProfileRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetProfileRequest {
    return new GetProfileRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetProfileRequest | PlainMessage<GetProfileRequest> | undefined, b: GetProfileRequest | PlainMessage<GetProfileRequest> | undefined): boolean {
    return proto3.util.equals(GetProfileRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.VerifyEmailRequest
 */
export class VerifyEmailRequest extends Message<VerifyEmailRequest> {
  /**
   * @generated from field: string verification_code = 1;
   */
  verificationCode = "";

  constructor(data?: PartialMessage<VerifyEmailRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.VerifyEmailRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "verification_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VerifyEmailRequest {
    return new VerifyEmailRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VerifyEmailRequest {
    return new VerifyEmailRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VerifyEmailRequest {
    return new VerifyEmailRequest().fromJsonString(jsonString, options);
  }

  static equals(a: VerifyEmailRequest | PlainMessage<VerifyEmailRequest> | undefined, b: VerifyEmailRequest | PlainMessage<VerifyEmailRequest> | undefined): boolean {
    return proto3.util.equals(VerifyEmailRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.ResendVerificationEmailRequest
 */
export class ResendVerificationEmailRequest extends Message<ResendVerificationEmailRequest> {
  constructor(data?: PartialMessage<ResendVerificationEmailRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.ResendVerificationEmailRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ResendVerificationEmailRequest {
    return new ResendVerificationEmailRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ResendVerificationEmailRequest {
    return new ResendVerificationEmailRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ResendVerificationEmailRequest {
    return new ResendVerificationEmailRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ResendVerificationEmailRequest | PlainMessage<ResendVerificationEmailRequest> | undefined, b: ResendVerificationEmailRequest | PlainMessage<ResendVerificationEmailRequest> | undefined): boolean {
    return proto3.util.equals(ResendVerificationEmailRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.ChangePreferredRegionRequest
 */
export class ChangePreferredRegionRequest extends Message<ChangePreferredRegionRequest> {
  /**
   * @generated from field: string new_region = 1;
   */
  newRegion = "";

  constructor(data?: PartialMessage<ChangePreferredRegionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.ChangePreferredRegionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "new_region", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangePreferredRegionRequest {
    return new ChangePreferredRegionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangePreferredRegionRequest {
    return new ChangePreferredRegionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangePreferredRegionRequest {
    return new ChangePreferredRegionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ChangePreferredRegionRequest | PlainMessage<ChangePreferredRegionRequest> | undefined, b: ChangePreferredRegionRequest | PlainMessage<ChangePreferredRegionRequest> | undefined): boolean {
    return proto3.util.equals(ChangePreferredRegionRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.ChangeLocaleRequest
 */
export class ChangeLocaleRequest extends Message<ChangeLocaleRequest> {
  /**
   * @generated from field: string new_locale = 1;
   */
  newLocale = "";

  constructor(data?: PartialMessage<ChangeLocaleRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.ChangeLocaleRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "new_locale", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangeLocaleRequest {
    return new ChangeLocaleRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangeLocaleRequest {
    return new ChangeLocaleRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangeLocaleRequest {
    return new ChangeLocaleRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ChangeLocaleRequest | PlainMessage<ChangeLocaleRequest> | undefined, b: ChangeLocaleRequest | PlainMessage<ChangeLocaleRequest> | undefined): boolean {
    return proto3.util.equals(ChangeLocaleRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.ChangeCurrencyRequest
 */
export class ChangeCurrencyRequest extends Message<ChangeCurrencyRequest> {
  /**
   * @generated from field: string new_currency = 1;
   */
  newCurrency = "";

  constructor(data?: PartialMessage<ChangeCurrencyRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.ChangeCurrencyRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "new_currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangeCurrencyRequest {
    return new ChangeCurrencyRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangeCurrencyRequest {
    return new ChangeCurrencyRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangeCurrencyRequest {
    return new ChangeCurrencyRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ChangeCurrencyRequest | PlainMessage<ChangeCurrencyRequest> | undefined, b: ChangeCurrencyRequest | PlainMessage<ChangeCurrencyRequest> | undefined): boolean {
    return proto3.util.equals(ChangeCurrencyRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.ChangeTimezoneRequest
 */
export class ChangeTimezoneRequest extends Message<ChangeTimezoneRequest> {
  /**
   * @generated from field: string new_timezone = 1;
   */
  newTimezone = "";

  constructor(data?: PartialMessage<ChangeTimezoneRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.ChangeTimezoneRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "new_timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangeTimezoneRequest {
    return new ChangeTimezoneRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangeTimezoneRequest {
    return new ChangeTimezoneRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangeTimezoneRequest {
    return new ChangeTimezoneRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ChangeTimezoneRequest | PlainMessage<ChangeTimezoneRequest> | undefined, b: ChangeTimezoneRequest | PlainMessage<ChangeTimezoneRequest> | undefined): boolean {
    return proto3.util.equals(ChangeTimezoneRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.ChangeParanoidRequest
 */
export class ChangeParanoidRequest extends Message<ChangeParanoidRequest> {
  /**
   * @generated from field: gportal.type.v1.Paranoid new_paranoid = 1;
   */
  newParanoid = Paranoid.UNSPECIFIED;

  constructor(data?: PartialMessage<ChangeParanoidRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.ChangeParanoidRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "new_paranoid", kind: "enum", T: proto3.getEnumType(Paranoid) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangeParanoidRequest {
    return new ChangeParanoidRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangeParanoidRequest {
    return new ChangeParanoidRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangeParanoidRequest {
    return new ChangeParanoidRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ChangeParanoidRequest | PlainMessage<ChangeParanoidRequest> | undefined, b: ChangeParanoidRequest | PlainMessage<ChangeParanoidRequest> | undefined): boolean {
    return proto3.util.equals(ChangeParanoidRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.NewsletterOptInRequest
 */
export class NewsletterOptInRequest extends Message<NewsletterOptInRequest> {
  /**
   * @generated from field: optional string email = 1;
   */
  email?: string;

  /**
   * @generated from field: optional string locale = 2;
   */
  locale?: string;

  /**
   * @generated from field: optional string language = 3;
   */
  language?: string;

  constructor(data?: PartialMessage<NewsletterOptInRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.NewsletterOptInRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "locale", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "language", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NewsletterOptInRequest {
    return new NewsletterOptInRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NewsletterOptInRequest {
    return new NewsletterOptInRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NewsletterOptInRequest {
    return new NewsletterOptInRequest().fromJsonString(jsonString, options);
  }

  static equals(a: NewsletterOptInRequest | PlainMessage<NewsletterOptInRequest> | undefined, b: NewsletterOptInRequest | PlainMessage<NewsletterOptInRequest> | undefined): boolean {
    return proto3.util.equals(NewsletterOptInRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.NewsletterOptOutRequest
 */
export class NewsletterOptOutRequest extends Message<NewsletterOptOutRequest> {
  constructor(data?: PartialMessage<NewsletterOptOutRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.NewsletterOptOutRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NewsletterOptOutRequest {
    return new NewsletterOptOutRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NewsletterOptOutRequest {
    return new NewsletterOptOutRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NewsletterOptOutRequest {
    return new NewsletterOptOutRequest().fromJsonString(jsonString, options);
  }

  static equals(a: NewsletterOptOutRequest | PlainMessage<NewsletterOptOutRequest> | undefined, b: NewsletterOptOutRequest | PlainMessage<NewsletterOptOutRequest> | undefined): boolean {
    return proto3.util.equals(NewsletterOptOutRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.CheckLootPassDiscordStatusRequest
 */
export class CheckLootPassDiscordStatusRequest extends Message<CheckLootPassDiscordStatusRequest> {
  constructor(data?: PartialMessage<CheckLootPassDiscordStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.CheckLootPassDiscordStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckLootPassDiscordStatusRequest {
    return new CheckLootPassDiscordStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckLootPassDiscordStatusRequest {
    return new CheckLootPassDiscordStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckLootPassDiscordStatusRequest {
    return new CheckLootPassDiscordStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CheckLootPassDiscordStatusRequest | PlainMessage<CheckLootPassDiscordStatusRequest> | undefined, b: CheckLootPassDiscordStatusRequest | PlainMessage<CheckLootPassDiscordStatusRequest> | undefined): boolean {
    return proto3.util.equals(CheckLootPassDiscordStatusRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.LinkLootPassDiscordRoleRequest
 */
export class LinkLootPassDiscordRoleRequest extends Message<LinkLootPassDiscordRoleRequest> {
  constructor(data?: PartialMessage<LinkLootPassDiscordRoleRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.LinkLootPassDiscordRoleRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LinkLootPassDiscordRoleRequest {
    return new LinkLootPassDiscordRoleRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LinkLootPassDiscordRoleRequest {
    return new LinkLootPassDiscordRoleRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LinkLootPassDiscordRoleRequest {
    return new LinkLootPassDiscordRoleRequest().fromJsonString(jsonString, options);
  }

  static equals(a: LinkLootPassDiscordRoleRequest | PlainMessage<LinkLootPassDiscordRoleRequest> | undefined, b: LinkLootPassDiscordRoleRequest | PlainMessage<LinkLootPassDiscordRoleRequest> | undefined): boolean {
    return proto3.util.equals(LinkLootPassDiscordRoleRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.GetSubscriptionInfosRequest
 */
export class GetSubscriptionInfosRequest extends Message<GetSubscriptionInfosRequest> {
  /**
   * @generated from field: repeated string product_types = 1;
   */
  productTypes: string[] = [];

  constructor(data?: PartialMessage<GetSubscriptionInfosRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.GetSubscriptionInfosRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "product_types", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSubscriptionInfosRequest {
    return new GetSubscriptionInfosRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSubscriptionInfosRequest {
    return new GetSubscriptionInfosRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSubscriptionInfosRequest {
    return new GetSubscriptionInfosRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetSubscriptionInfosRequest | PlainMessage<GetSubscriptionInfosRequest> | undefined, b: GetSubscriptionInfosRequest | PlainMessage<GetSubscriptionInfosRequest> | undefined): boolean {
    return proto3.util.equals(GetSubscriptionInfosRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.GetGamecloudSubscriptionsRequest
 */
export class GetGamecloudSubscriptionsRequest extends Message<GetGamecloudSubscriptionsRequest> {
  constructor(data?: PartialMessage<GetGamecloudSubscriptionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.GetGamecloudSubscriptionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetGamecloudSubscriptionsRequest {
    return new GetGamecloudSubscriptionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetGamecloudSubscriptionsRequest {
    return new GetGamecloudSubscriptionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetGamecloudSubscriptionsRequest {
    return new GetGamecloudSubscriptionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetGamecloudSubscriptionsRequest | PlainMessage<GetGamecloudSubscriptionsRequest> | undefined, b: GetGamecloudSubscriptionsRequest | PlainMessage<GetGamecloudSubscriptionsRequest> | undefined): boolean {
    return proto3.util.equals(GetGamecloudSubscriptionsRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.PauseGamecloudSubscriptionRequest
 */
export class PauseGamecloudSubscriptionRequest extends Message<PauseGamecloudSubscriptionRequest> {
  /**
   * @generated from field: string subscription_id = 1;
   */
  subscriptionId = "";

  constructor(data?: PartialMessage<PauseGamecloudSubscriptionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.PauseGamecloudSubscriptionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subscription_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PauseGamecloudSubscriptionRequest {
    return new PauseGamecloudSubscriptionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PauseGamecloudSubscriptionRequest {
    return new PauseGamecloudSubscriptionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PauseGamecloudSubscriptionRequest {
    return new PauseGamecloudSubscriptionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: PauseGamecloudSubscriptionRequest | PlainMessage<PauseGamecloudSubscriptionRequest> | undefined, b: PauseGamecloudSubscriptionRequest | PlainMessage<PauseGamecloudSubscriptionRequest> | undefined): boolean {
    return proto3.util.equals(PauseGamecloudSubscriptionRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.user.v1.ResumeGamecloudSubscriptionRequest
 */
export class ResumeGamecloudSubscriptionRequest extends Message<ResumeGamecloudSubscriptionRequest> {
  /**
   * @generated from field: string subscription_id = 1;
   */
  subscriptionId = "";

  constructor(data?: PartialMessage<ResumeGamecloudSubscriptionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.ResumeGamecloudSubscriptionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subscription_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ResumeGamecloudSubscriptionRequest {
    return new ResumeGamecloudSubscriptionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ResumeGamecloudSubscriptionRequest {
    return new ResumeGamecloudSubscriptionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ResumeGamecloudSubscriptionRequest {
    return new ResumeGamecloudSubscriptionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ResumeGamecloudSubscriptionRequest | PlainMessage<ResumeGamecloudSubscriptionRequest> | undefined, b: ResumeGamecloudSubscriptionRequest | PlainMessage<ResumeGamecloudSubscriptionRequest> | undefined): boolean {
    return proto3.util.equals(ResumeGamecloudSubscriptionRequest, a, b);
  }
}

